<template>
  <div class="main-navigation">
    <div class="main-navigation__container">
      <base-icon
        class="main-navigation__toggler"
        style="height: 30px; align-self: center;"
        icon="hamburger-menu"
        @click="$refs.drawer.open()"
      />
      <main-logo
        width="50px"
        height="15.87px"
        class="main-navigation__logo"
        @click.native="$emit('goToDashboard')"
      />
      <nav class="main-navigation__menu">
        <ul>
          <li
            v-for="(tab, index) in tabs"
            :key="index"
            class="main-navigation__item"
            @click="goto(tab)"
          >
            <div v-if="tab.text == 'Appointments'" style="width: 100%; text-align:center;" class="itemIcon">
              <base-icon class="appointmenIcon" :icon="tab.icon" @click="changeTab(tab.link)" />
            </div>
          </li>
        </ul>
      </nav>
      <slot name="right" />
    </div>
    <main-navigation-drawer ref="drawer">
      <main-navigation-drawer-item
        v-for="(tab, index) in tabs"
        :key="`drawer-item-${index}`"
        :selected="index === currentTabIndex"
        @click="goto(tab)"
      >
        <div class="row justify-content-md-center">
          <div class="col col-lg-2">
            <base-icon :icon="tab.icon" @click="changeTab(tab.link)" />
          </div>
          <div
            class="col col-lg-2 itemTitle--selected"
            :style="`${ index === currentTabIndex ? 'border-bottom: solid 1px #E7873C; padding-bottom:5px;': '' }`"
          >
            {{ tab.text }}
          </div>
        </div>
      </main-navigation-drawer-item>
    </main-navigation-drawer>
  </div>
</template>

<script>
import MainNavigationDrawer from './MainNavigationDrawer';
import MainNavigationDrawerItem from './MainNavigationDrawerItem';

export default {
  name: 'MainNavigation',
  components: { MainNavigationDrawer, MainNavigationDrawerItem },
  props: {
    /** Current route. Likely redundant with this.$route.path . */
    current: {
      type: String,
      default: '',
    },
    tabs: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    /** Index of the current active tab. Matches the first tab.link matching any part of the current url */
    currentTabIndex() {
      const sortedSearch = this.tabs.map((t, index) => ({ position: this.current.search(t.link), index }))
        .filter((route) => route.position >= 0).sort((r1, r2) => r1.position - r2.position);

      return sortedSearch.length ? sortedSearch[0].index : -1;
    },
  },
  methods: {
    goto(evt) {
      this.$refs.drawer.close();
      this.$emit('goto', evt.link);
    },
  },
};
</script>

<style lang="scss" scoped>
.main-navigation{
  background-color: white;
  padding-top: 1%;
  border-bottom: 1px solid #E2E2E2 !important;
  max-height: 64px;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: $zindex-menu;
  @media (min-width: map-get($breakpoints,'lg')) {
    box-shadow: none;
  }

  &__container{
    margin-top: -1%;
    width: 100%;
    height: 64px;
    max-width: 100%;
    padding-left: 19px;
    padding-right: 1rem;
    display: flex;
    align-items: stretch;
  }

  &__logo{
    align-self: center;
    margin: 0 auto;
    cursor: pointer;
    transform: translate(64px); // Visual centering

    @media (min-width: map-get($breakpoints,'lg')) {
      margin: 0;
      transform: translate(0);
    }
  }

  &__toggler{
    display: block;
    @media (min-width: map-get($breakpoints,'lg')) {
      display: none;
    }
  }

  &__menu{
    margin: 0 0 0 auto;
    display: none;
    @media (min-width: map-get($breakpoints,'lg')) {
      display: flex;
    }
    ul{
      padding: 0;
      margin: 0;
      display: flex;
    }
  }

  &__item {
    color: $black;
    // padding: 0 0 0 1rem;
    font-size: 0.8125rem;
    font-family: $font-family-sans-serif-light;
    // margin: 0 0.25rem;
    border-bottom: solid 1px transparent;
    -webkit-transition: border 0.5s;
    transition: border 0.5s;
    outline: none;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    // @media (min-width: map-get($breakpoints, 'lg')) {
    //   padding: 0 0.2rem;
    // }
    // @media (min-width: map-get($breakpoints, 'xl')) {
    //   padding: 0 0 0 1rem;
    // }
    span{
      padding: 0 10px;
      border-bottom: 1px solid rgba($black, 0);
      transition: border 0.3s;
    }
    &--active{
      font-family: $font-family-sans-serif-medium;
      border-bottom: 1px solid rgba($black, 1) !important;
    }
  }
}
.itemIcon{
 margin-right: 4px;
}
.appointmenIcon{
  width: 24px;
  height:24px;
}
.itemTitle{
  font-size:24px;
  line-height: 20px;
  font-family: 'SilkaLight';
  color: #646464;
}
</style>
